<script src="https://www.google.com/jsapi"></script>

<form>
  <div class="row">
    <div class="col-md-12" *ngIf="documentPreviewTypes.document">
      <ngx-doc-viewer
        [url]="previewMatadata?.url"
        viewer="google"
        style="width: 100%; height: 93vh"
        (loaded)="documentLoaded()"
      >
      </ngx-doc-viewer>
    </div>
    <div class="col-md-12" *ngIf="documentPreviewTypes.excel">
      <div class="iframe-container">
        <iframe
          style="width: 100%; height: 93vh"
          frameborder="0"
          [src]="previewMatadata?.docurl"
          class="sheet-ready">
        </iframe>
        <div class="absolute"></div>
      </div>
    </div>
    <div
      class="col-md-12"
      *ngIf="documentPreviewTypes.pdf && previewMatadata.url"
    ></div>
    <div class="col-md-12" *ngIf="documentPreviewTypes.image">
      <img *ngIf="previewMatadata?.url"
        class="image-preview"
        [src]="previewMatadata?.url"
        [alt]="previewMatadata?.name"
      />
    </div>
    <div class="col-md-12" *ngIf="documentPreviewTypes.video">
      <video controls='' class="image-preview" autoplay="" name="media">
        <source [src]="previewMatadata?.url" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="not-support" *ngIf="documentPreviewTypes.notpriview">
      Preview for this document is not supported.
    </div>
  </div>
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <button
        class="btn-prev-cls closes-button"
        type="submit"
        (click)="handelClosedDialogBox()"
      >
        Close
      </button>
    </div>
  </div>
</form>